import Lottie from 'react-lottie'

import animationData from './check-success.json'

const defaultOptions = {
  loop: false,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

const AnimationCheckSuccess = ({
  height,
  width
}) => (
  <Lottie options={defaultOptions}
      height={height}
      width={width}
    />
)

export default AnimationCheckSuccess